import {Injectable} from '@angular/core';
import {BehaviorSubject} from "rxjs";

@Injectable({
    providedIn: 'root'
})
export class MyWebDeskService {


    public kanbanBoard: boolean = true;
    public kanbanList: boolean;

    constructor() {
    }

    //kanban variables and functions

    public kanbanFilters = new BehaviorSubject<any>({});

    public kanbanListState = {todo: true, inprogress: true, ddone: true};

    public kanbanPreview = new BehaviorSubject<string>('table');


    getKanbanListState() {
        return this.kanbanListState;
    }

    setKanbanListState(data) {
        this.kanbanListState = data;
    }
}
